export default {
	"permission": {
		"role": "角色",
		"addRole": "添加角色",
		"roleName": "角色名称",
		"roleNameTips": "请填写角色名称"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/permission/permission.js